<form [formGroup]="form" (ngSubmit)="submit()">
  <div #titleElement mat-dialog-title i18n>Edit properties</div>
  <div mat-dialog-content class="px-4">
    <div
      class="ft-observe-interseting"
      (ftObserveIntersecting)="
        appService.setOverlapped($event, titleElement)
      "></div>
    <div class="d-flex flex-column gap-2">
      <mat-form-field class="w-100">
        <mat-label i18n>Beneficiary</mat-label>
        <mat-select formControlName="beneficiary" [compareWith]="compareItem">
          <mat-select-trigger>
            {{
              form.get('beneficiary')?.value?.description ||
                form.get('beneficiary')?.value?.alias ||
                ''
            }}
          </mat-select-trigger>
          @for (
            beneficiary of beneficiaries.accumulated() ?? [];
            track beneficiary.sequence
          ) {
            <mat-option [value]="beneficiary">
              {{ beneficiary.description }}
            </mat-option>
          }
          <mat-option
              isGranted="btn-add-beneficiary"
              (click)="openBeneficiary()">
              <div class="ft-item">
                <ft-icon name="plus" />
                <div i18n>New beneficiary</div>
              </div>
            </mat-option>
        </mat-select>
        @if (form.get('beneficiary')?.invalid) {
          <mat-error>
            {{ appService.getErrorMessage(form.get('beneficiary')) }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-100" isGranted="dwl-group">
        <mat-label i18n>Group</mat-label>
        <mat-select formControlName="group" [compareWith]="compareItem">
          <mat-select-trigger>
            {{ form.get('group')?.value?.description || '' }}
          </mat-select-trigger>
          <mat-option [value]="null" i18n>No group</mat-option>
          @for (group of groups.accumulated() ?? []; track group.sequence) {
            <mat-option [value]="group">{{ group.description }}</mat-option>
          }
          <mat-option
              isGranted="btn-add-group"
              (click)="openGroup()">
              <div class="ft-item">
                <ft-icon name="plus" />
                <div i18n>New group</div>
              </div>
            </mat-option>
        </mat-select>
        @if (form.get('group')?.invalid) {
          <mat-error>
            {{ appService.getErrorMessage(form.get('group')) }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <h3 i18n>Notifications</h3>
    <div class="d-flex flex-column mb-3 gap-3">
      <mat-checkbox [checked]="true" formControlName="notifyPayment">
        <div i18n>Payment reminder</div>
        <small class="text-muted" i18n>
          If you activate this option, we will send reminders to your
          beneficiary before each installment is due.
        </small>
      </mat-checkbox>
      <mat-checkbox [checked]="true" formControlName="notifyOverduePayment">
        <div i18n>Reminder of overdue payments</div>
        <small class="text-muted" i18n>
          If you activate this option, we will send reminders to your
          beneficiary about the pending installments.
        </small>
      </mat-checkbox>
      <mat-checkbox [checked]="true" formControlName="notifySendingReceipts">
        <div i18n>Sending receipts</div>
        <small class="text-muted" i18n>
          If you activate this option, we will send a notification to your
          beneficiary each time you record a payment on the loan.
        </small>
      </mat-checkbox>
    </div>
    <div
      class="ft-observe-interseting"
      (ftObserveIntersecting)="
        appService.setOverlapped($event, actionsElement)
      "></div>
  </div>
  <div #actionsElement mat-dialog-actions class="justify-content-center">
    <button
      type="button"
      mat-stroked-button
      [disabled]="submitting()"
      mat-dialog-close
      i18n>
      Cancel
    </button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="!form.valid || submitting()">
      @if (!submitting()) {
        <span i18n>Submit</span>
      } @else {
        <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
      }
    </button>
  </div>
</form>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>
